const mixinCalendar = {
  data() {
    return {
      isShowCalendar: false,
    };
  },
  methods: {
    showCalendar(model, farms, farmsToSearch = null) {
      this.$set(model, 'calendar_sel', null);
      this.isShowCalendar = true;

      let element = [];
      if (
        (farmsToSearch && Array.isArray(farmsToSearch)) ||
        (!farmsToSearch && model.farms && Array.isArray(model.farms))
      ) {
        const arrayFarms = farmsToSearch
          ? farmsToSearch
          : model.farms
          ? model.farms
          : [];
        Object.values(farms).forEach((el) => {
          if (arrayFarms.includes(el.id)) element.push(el);
        });
      } else if (farmsToSearch) {
        element = Object.values(farms).find((el) => el.id === farmsToSearch);
      }

      if (element) {
        if (Array.isArray(element)) {
          const elementFiltered = element.filter(
            (el) => el.calendars && el.calendars.length >= 1
          );
          this.isShowCalendar = elementFiltered.length > 1;
          this.$set(
            model,
            'calendar_sel',
            elementFiltered.length > 1
              ? null
              : elementFiltered.length == 1
              ? elementFiltered[0].id
              : null
          );
        } else {
          this.isShowCalendar = element.calendars.length > 1;
          this.$set(
            model,
            'calendar_sel',
            element.calendars.length > 1
              ? null
              : element.calendars.length == 1
              ? element.calendars[0].id
              : null
          );
        }
      }

      this.isShowCalendar = false;
    },
  },
};

export default mixinCalendar;
